var Widget          = require("./Widget"),
    $               = require("jquery");

var Panel = Widget.extend({

    options: {
        content: ""
    },

    initialize: function(options){
        var that = this;

        Panel.__super__.initialize.call(that, options);

        that._container.addClass('omjs-panel');

        $(that._container).append($('<div class="panel-container"></div>'));

        if (that.options.content) {
            if (typeof that.options.content == 'strting') {
                $(that._container).find('.panel-container').html(that.options.content);
            } else {
                $(that._container).find('.panel-container').append(that.options.content);
            }
        }

        that._contentContainer = $(that._container).find('.panel-container');
    },

    getContentContainer: function(){
        var that = this;
        return that._contentContainer;
    }
});

module.exports = Panel;


//////////////////
// WEBPACK FOOTER
// ./src/View/Widget/Panel.js
// module id = 209
// module chunks = 0